import {
   ADD_TRAVEL_ORDER,
  ADD_TRAVEL_ORDER_START,
  ADD_TRAVEL_ORDER_ERROR,
  UPDATE_TRAVEL_ORDER,
  UPDATE_TRAVEL_ORDER_START,
  UPDATE_TRAVEL_ORDER_ERROR,
  GET_TRAVEL_ORDER,
  GET_TRAVEL_ORDER_LIST_START,
  GET_TRAVEL_ORDER_ERROR,
  GET_TRAVEL_ORDER_LIST_PAGEABLE_START,
  GET_TRAVEL_ORDER_LIST_PAGEABLE,
  GET_TRAVEL_ORDER_LIST_PAGEABLE_ERROR,
  DELETE_TRAVEL_ORDER,
  DELETE_TRAVEL_ORDER_START,
  DELETE_TRAVEL_ORDER_ERROR,
  CLEAR_ERROR_TRAVEL_ORDER,
  GET_TRAVEL_ORDER_LIST,
  GET_TRAVEL_ORDER_LIST_ERROR,
} from '../actions/types';

const initialState = {
  emptyList: false,
  travelOrderList: [],
  travelOrder: {},
  loading: false,
  error: undefined,
  totalElements: '',
  pageNumber: -1,
  pageSize: 8,
  isLastPage: false,
};

const clearError = (state) => {
  return {
    ...state,
    error: undefined,
  };
};

const addTravelOrderStart = (state) => {
  return {
    ...state,
    loading: false,
  };
};

const addTravelOrderError = (state, action) => {
  return {
    ...state,
    error: action.payload,
    loading: false,
  };
};

const addTravelOrder = (state, action) => {
  return {
    ...state,
    loading: false,
    travelOrderList: state.travelOrderList.concat(action.payload),
  };
};

const updateTravelOrderStart = (state) => {
  return {
    ...state,
  };
};

const updateTravelOrderError = (state, action) => {
  return {
    ...state,
    error: action.payload,
    loading: false,
  };
};

const updateTravelOrder = (state, action) => {
  return {
    ...state,

    travelOrderList: state.travelOrderList.map((travelOrder) =>
      travelOrder.id === action.payload.id ? action.payload : travelOrder
    ),
    loading: false,
  };
};

const findAllTravelOrderPageableStart = (state) => {
  return {
    ...state,
    loading: true,
  };
};

const findAllTravelOrderPageableError = (state, action) => {
  return {
    ...state,
    error: action.payload,
  };
};

const findAllTravelOrderPageable = (state, action) => {
  return {
    ...state,
    travelOrderList: [...action.payload.list],
    totalElements: action.payload.totalElements,
  };
};

const deleteTravelOrderStart = (state) => {
  return {
    ...state,
    loading: true,
  };
};

const deleteTravelOrderError = (state, action) => {
  return {
    ...state,
    error: action.payload,
    loading: false,
  };
};

const deleteTravelOrder = (state, action) => {
  return {
    ...state,
    loading: false,
    travelOrderList: state.travelOrderList.filter(
      (travelOrder) => travelOrder.id !== action.payload
    ),
  };
};

const findTravelOrderByIdStart = (state) => {
  return {
    ...state,
    loading: true,
  };
};

const findTravelOrderByIdError = (state, action) => {
  return {
    ...state,
    error: action.payload,
    loading: false,
  };
};

const findTravelOrderById = (state, action) => {
  return {
    ...state,
    loading: false,
    travelOrder: action.payload,
  };
};

const findAllTravelOrderStart = (state) => {
  return {
    ...state,
    loading: true,
  };
};

const findAllTravelOrderError = (state, action) => {
  return {
    ...state,
    error: action.payload,
    loading: false,
  };
};

const findAllTravelOrder = (state, action) => {
  return {
    ...state,
    loading: false,
    travelOrderList: action.payload,
  };
};

export default function (state = initialState, action) {
  switch (action.type) {
    case ADD_TRAVEL_ORDER:
      return addTravelOrder(state, action);
    case ADD_TRAVEL_ORDER_START:
      return addTravelOrderStart(state);
    case ADD_TRAVEL_ORDER_ERROR:
      return addTravelOrderError(state, action);

    case UPDATE_TRAVEL_ORDER:
      return updateTravelOrder(state, action);
    case UPDATE_TRAVEL_ORDER_START:
      return updateTravelOrderStart(state);
    case UPDATE_TRAVEL_ORDER_ERROR:
      return updateTravelOrderError(state, action);

    case GET_TRAVEL_ORDER:
      return findTravelOrderById(state, action);
    case GET_TRAVEL_ORDER_LIST_START:
      return findTravelOrderByIdStart(state);
    case GET_TRAVEL_ORDER_ERROR:
      return findTravelOrderByIdError(state, action);

    case GET_TRAVEL_ORDER_LIST_PAGEABLE_START:
      return findAllTravelOrderPageableStart(state, action);
    case GET_TRAVEL_ORDER_LIST_PAGEABLE:
      return findAllTravelOrderPageable(state, action);
    case GET_TRAVEL_ORDER_LIST_PAGEABLE_ERROR:
      return findAllTravelOrderPageableError(state, action);

    case DELETE_TRAVEL_ORDER:
      return deleteTravelOrder(state, action);
    case DELETE_TRAVEL_ORDER_START:
      return deleteTravelOrderStart(state);
    case DELETE_TRAVEL_ORDER_ERROR:
      return deleteTravelOrderError(state, action);
    case CLEAR_ERROR_TRAVEL_ORDER:
      return clearError(state);

    case GET_TRAVEL_ORDER_LIST:
      return findAllTravelOrder(state, action);
    case GET_TRAVEL_ORDER_LIST_START:
      return findAllTravelOrderStart(state);
    case GET_TRAVEL_ORDER_LIST_ERROR:
      return findAllTravelOrderError(state, action);

    default:
      return state;
  }
}
